import Vue from "vue";
import Vuex from "vuex";
import { firestore, } from "@/firebase";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    editUser: null,
    editPqr: null,
    editNormativity: null,
  },
  mutations: {
    SET_USER: (state, payload) => state.user = payload,
    SET_EDIT_USER: (state, payload) => state.editUser = payload,
    SET_EDIT_PQR: (state, payload) => state.editPqr = payload,
    SET_EDIT_NORMATIVITY: (state, payload) => state.editNormativity = payload,
  },
  actions: {
    SIGN_IN: async ({ commit, }, uid) => {
      const snapshot = await firestore.doc(`/users/${uid}`).get();
      commit("SET_USER", { ...snapshot.data(), ...{ uid, }});
    },
  },
});